import { Feather } from 'lucide-react';
import { sourceKindOf, type SourceSystem } from '@hector/shared-types';
import { WordIcon } from './WordIcon';

interface Props {
  sourceSystem: SourceSystem | string | null | undefined;
  className?: string;
}

/**
 * Corner badge shown at the top-right of a conversation item.
 * Word logo = Word conversations (agent édition), Feather = Workspace
 * (case discovery + legacy). Tooltip appears instantly on hover (CSS-only,
 * no delay) — the icon alone is opaque without an immediate label.
 */
export function ConversationSourceBadge({ sourceSystem, className = '' }: Props) {
  const kind = sourceKindOf(sourceSystem);
  const label = kind === 'word' ? 'Conversation Word' : 'Conversation Espace de travail';

  return (
    <span
      className={`relative group/badge inline-flex items-center justify-center text-grey-400 ${className}`}
      aria-label={label}
    >
      {kind === 'word' ? <WordIcon size={12} /> : <Feather size={12} />}
      <span
        className="absolute right-0 top-full z-50 mt-1 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs font-normal text-white shadow pointer-events-none opacity-0 group-hover/badge:opacity-100 transition-opacity"
      >
        {label}
      </span>
    </span>
  );
}
